document.addEventListener('DOMContentLoaded', function () {
  if (!window.mapboxgl) return;

  mapboxgl.accessToken = 'pk.eyJ1IjoiY2hlcmVsaWUiLCJhIjoiY21qMzQ3aWhpMHo5MDNlcXdtZ3YxNnVlYSJ9.qskAhG5M5XSZvLKlpUEpIw';

  const el = document.getElementById('mapbox-map-interactive');
  if (!el) return;

  const map = new mapboxgl.Map({
    container: el,
    style: 'mapbox://styles/cherelie/cmj34h3v5009p01sehn4xgpuz',
    center: [13.404954, 52.520008],
    zoom: 12
  });

  map.on('load', () => {
    setTimeout(() => map.resize(), 0);
  });
});